import { useState, useEffect } from 'react';

// mui
import { Box, Typography } from '@mui/material';

function Message(props) {
    const [variant, setVariant] = useState('subtitle1');

    useEffect(() => {
        if (props.variant) {
            setVariant(props.variant);
        }
    }, [props.variant]);

    return (
        <Box
            sx={{
                ...props.sx,
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                height: '100%',
                m: 0,
                p: 0,
            }}>
            <Typography color='primary.light' variant={variant} sx={{ textAlign: 'center', whiteSpace: 'pre-line' }}>
                {props.message}
            </Typography>
        </Box>
    );
}

export { Message };
